export enum RulebookStyle {
    Popup = 'popup',
    Fullscreen = 'fullscreen',
    Discord = 'discord',
}

export enum RulebookPage {
    Classic4P = 'bg',
    Classic56P = '56p',
    Seafarers4P = 'sf',
    CitiesAndKnights4P = 'ck',
}

export function getRulebookPagePathname(page: RulebookPage): string {
    switch(page) {
        case RulebookPage.Classic4P: return ''
        case RulebookPage.Classic56P: return '/5-6-player'
        case RulebookPage.Seafarers4P: return '/seafarers'
        case RulebookPage.CitiesAndKnights4P: return '/cities-and-knights'
    }
}

export function getRulebookStylePathname(style: RulebookStyle): string {
    if(style == RulebookStyle.Fullscreen) {
        return ''
    } else {
        return `/${style}`
    }
}
